import { usePut } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateAccountFlagDefinition() {
  const put = usePut(true, "tms");
  const updateAccountFlagDefinition = (id: string, request) =>
    put<{ id: string }>(`${referenceDataBaseUrl}/account-flag-definitions/${id}`, request);

  return useMutationWithErrorHandling({
    mutationFn: async ({ id, request }: { id: string; request }) =>
      await updateAccountFlagDefinition(id, request),
  });
}
